import React, { useRef, useState } from 'react';
import {
	ReactSketchCanvas,
	type ReactSketchCanvasRef,
} from 'react-sketch-canvas';

interface Props {
	name: string;
	isRequired?: boolean;
	netteRules?: any;
}

const DrawingInput: React.FC<Props> = ({ name, isRequired, netteRules }) => {
	const canvasRef = useRef<ReactSketchCanvasRef>(null);
	const [textInput, setTextInput] = useState<string>('');

	const logDrawing = async () => {
		if (!canvasRef.current) return;
		try {
			const dataUrl = await canvasRef.current.exportImage('png');
			setTextInput(dataUrl);
		} catch (error) {
			console.error('Drawing error:', error);
		}
	};

	return (
		<>
			<ReactSketchCanvas
				ref={canvasRef}
				width='100%'
				height='300px'
				canvasColor='transparent'
				strokeColor='#000000'
				onStroke={logDrawing}
			/>
			<input
				style={{ display: 'none' }}
				type='text'
				value={textInput}
				name={name}
				required={isRequired}
				data-nette-rules={netteRules}
			/>
		</>
	);
};

export default DrawingInput;
